import React from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import { Button } from '../components/ui/button';
import { Card } from '../components/ui/card';
import { CheckCircle, Video, Calendar, XCircle } from 'lucide-react';

const MeetingConfirmed = () => {
  const { meetingId } = useParams();
  const navigate = useNavigate();

  return (
    <div className="min-h-screen bg-gradient-to-br from-slate-50 via-blue-50 to-slate-100 flex items-center justify-center py-8 px-4">
      <Card className="max-w-2xl w-full p-8 bg-white shadow-xl">
        <div className="text-center">
          <div className="w-20 h-20 bg-green-100 rounded-full flex items-center justify-center mx-auto mb-6">
            <CheckCircle className="w-12 h-12 text-green-600" />
          </div>
          
          <h1 className="text-3xl font-bold text-slate-900 mb-3" style={{fontFamily: 'Space Grotesk, sans-serif'}}>
            Meeting Scheduled!
          </h1>
          <p className="text-lg text-slate-600 mb-8">
            Check your email for confirmation and meeting details
          </p>

          <div className="bg-slate-50 rounded-lg p-6 mb-8 text-left">
            <h3 className="font-semibold text-slate-900 mb-3">What's Next?</h3>
            <ul className="space-y-2 text-sm text-slate-700">
              <li className="flex items-start gap-2">
                <span className="text-green-600 mt-1">✓</span>
                <span>You'll receive a confirmation email with the meeting link</span>
              </li>
              <li className="flex items-start gap-2">
                <span className="text-green-600 mt-1">✓</span>
                <span>Reminders will be sent 1 day and 2 hours before the meeting</span>
              </li>
              <li className="flex items-start gap-2">
                <span className="text-green-600 mt-1">✓</span>
                <span>You can reschedule or cancel using the links in your email</span>
              </li>
            </ul>
          </div>

          <div className="flex gap-3 justify-center">
            <Button
              onClick={() => navigate('/')}
              variant="outline"
              className="rounded-full"
            >
              Back to Home
            </Button>
            <Button
              onClick={() => navigate('/digi-connect')}
              className="bg-slate-900 hover:bg-slate-800 text-white rounded-full"
            >
              Explore Digi Connect
            </Button>
          </div>
        </div>
      </Card>
    </div>
  );
};

export default MeetingConfirmed;
